import * as React from 'react';
import { TaQuestionData } from '../../ta-shared';

type TaQuestionBoxProps = {
	currentQuestion: TaQuestionData;
	onUpdateStep: (value?: string) => void;
};

export const TaQuestionBox = ({
	currentQuestion,
	onUpdateStep,
}: TaQuestionBoxProps) => {
	const emitQuestionClick = (value: string) => {
		onUpdateStep(value);
	};

	const renderButtons = () => {
		return currentQuestion.buttons.map((button) => {
			return (
				<button
					className='ta-question-box_button'
					value={button.value}
					key={button.value}
					onClick={() => emitQuestionClick(button.value)}
				>
					{button.text}
				</button>
			);
		});
	};

	return (
		<div className='ta-question-box'>
			<div className='ta-question-bar'>
				<div
					className='ta-question-bar-fill'
					style={{ width: currentQuestion.step * 15 }}
				/>
			</div>
			<div className='ta-question-box_text'>
				{currentQuestion.question}
			</div>
			<div className='ta-question-box_buttons'>{renderButtons()}</div>
		</div>
	);
};
